import { CheckCircle2, Zap, Shield, Microscope, Users, Globe, Headphones, Sparkles } from "lucide-react";

export default function WhyChooseKapilTech() {
  const benefits = [
    {
      text: "Faster access to qualified candidates",
      icon: Zap,
      color: "#0058a9",
      lightBg: "#e8f2fa"
    },
    {
      text: "Reduced hiring risk",
      icon: Shield,
      color: "#0d9488",
      lightBg: "#f0fdfa"
    },
    {
      text: "Specialized technology recruitment expertise",
      icon: Microscope,
      color: "#1a2332",
      lightBg: "#f0f2f5"
    },
    {
      text: "Flexible hiring models",
      icon: Users,
      color: "#ff7a01",
      lightBg: "#fff2e6"
    },
    {
      text: "Dedicated recruitment support",
      icon: Headphones,
      color: "#0058a9",
      lightBg: "#e8f2fa"
    },
    {
      text: "Global talent network",
      icon: Globe,
      color: "#0d9488",
      lightBg: "#f0fdfa"
    }
  ];

  return (
    <section
      className="w-full py-20 md:py-28 lg:py-32"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        
        {/* Header Section */}
        <div className="text-center mb-16">
          {/* Bubble tag */}
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-2 h-2 bg-black rounded-full"></div>
            <p 
              className="text-sm font-medium uppercase tracking-wider"
              style={{ 
                fontFamily: '"Open Sans", sans-serif',
                fontSize: '14px',
                fontWeight: 500,
                color: '#081120'
              }}
            >
              Why Partner With Us
            </p>
          </div>

          <h3
            className="text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-5"
            style={{ 
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 600,
              color: '#081120'
            }}
          >
            Why Choose Kapil Tech for <br />
            <span className="text-transparent bg-clip-text" 
                  style={{ backgroundImage: 'linear-gradient(135deg, #0058a9, #0d9488)' }}>
              IT Recruitment Services
            </span>
          </h3>
          
          <p
            className="text-base max-w-2xl mx-auto"
            style={{ 
              fontFamily: '"Open Sans", sans-serif',
              fontSize: '16px',
              lineHeight: '180%',
              color: '#555658'
            }}
          >
            We combine speed, quality, and expertise to deliver the technical talent your business needs to grow
          </p>
        </div>

        {/* Split Layout: Benefits Grid | Image */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Left Side - Benefits Grid (New UI) */}
          <div className="grid sm:grid-cols-2 gap-4">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div
                  key={index}
                  className="group flex items-start gap-3 p-4 rounded-xl transition-all duration-300 hover:shadow-md cursor-pointer"
                  style={{ 
                    backgroundColor: benefit.lightBg,
                    transform: 'translateY(0)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <div 
                    className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-300 group-hover:scale-110"
                    style={{ backgroundColor: `${benefit.color}15` }}
                  >
                    <Icon className="w-4 h-4" style={{ color: benefit.color }} />
                  </div>
                  <p 
                    className="text-sm font-medium leading-tight"
                    style={{ 
                      fontFamily: '"Open Sans", sans-serif',
                      fontSize: '14px',
                      fontWeight: 500,
                      color: '#081120'
                    }}
                  >
                    {benefit.text}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Right Side - Image with modern overlay */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Home/Kapil%20Tech.jpg?updatedAt=1780547975797"
                alt="Kapil Tech recruitment team in modern office"
                className="w-full h-auto object-cover transition-all duration-700 hover:scale-105"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = "https://placehold.co/800x600/eef2f6/081120?text=IT+Recruitment+Team";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}